import { h, render } from 'preact'; /** @jsx h */

import NotFound404 from './pages/404';
import Roy from './pages/alt-er-pa-vei';
import KjellGunnar from './pages/fant-mannen-sin-blodig-og-bevisstlos';
import FoertiMinutterHLR from './pages/foerti-minutter-hlr';
import HanDodeForanOyneneVare from './pages/han-dode-foran-oynene-vare';
import Olav from './pages/kampen-for-bestefars-liv';
import ReddetAvKollegaene from './pages/reddet-av-kollegaene';
import SnoskredetSomTokTommy from './pages/snoskredet-som-tok-tommy';
import TorArne from './pages/nektet-a-gi-opp';

import './styles/styles.scss';

const body = document.body;
const container = document.getElementById('historie');
const urlPath = window.location.pathname;
const slug = urlPath.split('/')[2];

let pageComponent;

switch (urlPath) {
    case '/historie/reddet-av-kollegaene/':
        pageComponent = <ReddetAvKollegaene slug={slug} />;
        break;
    case '/historie/snoskredet-som-tok-tommy/':
        pageComponent = <SnoskredetSomTokTommy slug={slug} />;
        break;
    case '/historie/40-minutter-med-hjerte-og-lungeredning/':
        pageComponent = <FoertiMinutterHLR slug={slug} />;
        break;
    case '/historie/han-dode-foran-oynene-vare/':
        pageComponent = <HanDodeForanOyneneVare slug={slug} />;
        break;
    case '/historie/alt-er-pa-vei/':
        pageComponent = <Roy slug={slug} />;
        break;
    case '/historie/kampen-for-bestefars-liv/':
        pageComponent = <Olav slug={slug} />;
        break;
    case '/historie/fant-mannen-sin-blodig-og-bevisstlos/':
        pageComponent = <KjellGunnar slug={slug} />;
        break;
    case '/historie/nektet-a-gi-opp/':
        pageComponent = <TorArne slug={slug} />;
        break;
    default:
        pageComponent = <NotFound404 slug={slug} />;
        break;
}

render(<div id="historie">{pageComponent}</div>, body, container);
